import React, { useEffect, useMemo, useState } from "react";
import { withTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setQuestionAnswer, setQuestionAnswerFrench } from "../../../../redux/actions";
import BackAnchor from "../../../../shared/components/BackAnchor";
import { addToGoogleDataLayer } from "../../../../shared/const/utls";
import ContinueCancelButtons from "../../../../shared/components/ContinueCancelButtons";
import { homeHeatingOptions } from "../../../../shared/const/data";

const HeatYourHomeView = ({ t, i18n }) => {
  const dispatch = useDispatch();
  const { questionDataList } = useSelector((state) => state?.app);
  const navigate = useNavigate();
  const params = useParams();
  const homeHeatState =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 13)
    ].questionAnswer;
  const [homeHeat, setHomeHeat] = useState(homeHeatState);
  const [homeHeatError, setHomeHeatError] = useState(false);
  const disableGApush = useMemo(() => {
    return JSON.parse(params.disableGA || false);
  }, [params]);
  const otherAdult =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 7)
    ].questionAnswer?.toLowerCase() === "yes"
  const moreAdults =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 8)
    ].questionAnswer?.toLowerCase();

  useEffect(() => {
    if (!disableGApush) {
      try {
        addToGoogleDataLayer(
          "heat-your-home",
          "HARP Application",
          i18n.language
        );
        window.scrollTo(0, 0);
      } catch (e) {
        console.log(e);
      }
    }
  }, [i18n.language, disableGApush]);

  const billUpload =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 4)
    ].questionAnswer?.toLowerCase() === "yes";
  const recievedLetter =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 2)
    ].questionAnswer?.toLowerCase() === "yes";

  const { search } = useLocation();
  const url = new URLSearchParams(search);

  // Get the value of the 'isSummary' parameter
  const isSummary = url?.get("isSummary");

  const onNext = () => {
    try {
      if (!homeHeat) {
        setHomeHeatError(true);
        return;
      }
      if (homeHeat && homeHeat !== "None") {
        // if (isSummary === "true") {
        //   navigate(`/${i18n.language}${t("routes.review_summary")}`);
        // } else 
        if (billUpload || recievedLetter) {
          navigate(`/${i18n.language}${t("routes.upload_heating_bill")}${isSummary ? `?isSummary=true` : ''}`);
        } else {
          navigate(`/${i18n.language}${t("routes.without_uploading_bill")}${isSummary ? `?isSummary=true` : ''}`);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleReduxCleanup = () => {
    dispatch(setQuestionAnswer(13, ''));
    dispatch(setQuestionAnswerFrench(13, ''));
  }

  const backPage = () => {
    if (otherAdult || moreAdults === 'two or more adults(with kids)' || moreAdults === 'two or more adults(no kids)') {
      return "routes.other_adults_form"
    } else {
      return "routes.personal_information"
    }
  }

  return (
    <div>
      <div className="container">
        <main>
          <article>
            <div className="row" style={{ paddingTop: "1em" }}></div>

            <BackAnchor backPath={backPage()} onBackClick={handleReduxCleanup} />

            <div className="row">
              <div className="col-sm-8 col-xs-12">
                <h1 style={{ marginBottom: "0" }}>
                  {t("harp_questions.heat_your_home")}
                </h1>
              </div>
              <div className="col-xs-12" style={{ marginTop: "10px" }}>
                <b>{t("shared.select_option_most")}</b>
              </div>
            </div>

            <div style={{ paddingBottom: "2em" }} className="row">
              <div className="col-xs-12 col-md-8">
                {homeHeatError && (
                  <div className="form-group has-error">
                    <div className="help-block">
                      <i
                        aria-label={t("shared.error")}
                        className="fa fa-exclamation-circle error-indicator errorAlert"
                        aria-hidden="true"
                      />
                      <span className="ns-visually-hidden">
                        {t("errors.hidden_error_msg")}
                      </span>
                      <span style={{ marginLeft: "10px" }}>
                        {t("errors.heat_home_error")}
                      </span>
                    </div>
                  </div>
                )}
                {homeHeatingOptions.map((opt, index) => (
                  // <div className="">
                  <div className="ns-radios__item col-xs-12" key={index}>
                    <input
                      className="ns-radios__input"
                      type="radio"
                      id={index}
                      name="own-radio"
                      value={opt?.value}
                      onChange={(e) => {
                        setHomeHeatError(false);
                        setHomeHeat(e.target.value);

                        dispatch(setQuestionAnswer(13, opt?.value));
                        dispatch(setQuestionAnswerFrench(13, opt?.valueFrench));
                      }}
                      checked={homeHeat === opt?.value}
                    />
                    <label
                      onClick={() => {
                        setHomeHeatError(false);
                        setHomeHeat(opt.value);
                        dispatch(setQuestionAnswer(13, opt?.value));
                        dispatch(setQuestionAnswerFrench(13, opt?.valueFrench));
                      }}
                      style={{ display: "block" }}
                      className=" ns-radios__label"
                      htmlFor="own-radio"
                      key="own-radio"
                    >
                      <p
                        className="ns-label ns-label-span"
                        style={{ marginBottom: "0" }}
                      >
                        {i18n.language === "en" ? opt.displayName : opt.valueFrench}
                      </p>
                    </label>
                  </div>
                  // </div>
                ))}
              </div>
            </div>
            <ContinueCancelButtons continueClick={onNext} />
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(HeatYourHomeView);
